import { cn } from '@/lib/utils'

interface ScoreBreakdownProps {
  label: string
  value: number
  maxValue?: number
}

function getBarColor(value: number): string {
  if (value >= 80) return 'bg-green-500'
  if (value >= 50) return 'bg-yellow-500'
  return 'bg-yellow-600'
}

export function ScoreBreakdown({ label, value, maxValue = 100 }: ScoreBreakdownProps) {
  const percentage = Math.min((value / maxValue) * 100, 100)

  return (
    <div className="flex items-center gap-3">
      <span className="text-xs sm:text-sm text-muted-foreground w-24 sm:w-44 shrink-0">
        {label}
      </span>
      <div className="flex-1 h-2.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-all duration-500', getBarColor(value))}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="text-sm font-medium w-10 text-right">{value}%</span>
    </div>
  )
}

interface OverallScoreProps {
  score: number
  className?: string
}

function getScoreColor(score: number): string {
  if (score >= 80) return 'text-green-600'
  if (score >= 60) return 'text-yellow-600'
  return 'text-red-600'
}

export function OverallScore({ score, className }: OverallScoreProps) {
  return (
    <div className={cn('text-center', className)}>
      <div className={cn('text-3xl sm:text-5xl font-bold', getScoreColor(score))}>{score}</div>
      <div className="text-xs sm:text-sm text-muted-foreground mt-1">Overall Score</div>
    </div>
  )
}
